import React from 'react';

import javascripticon from "../../../components/images/javascripticon.png";
import cssicon from "../../../components/images/jcssicon.png";

export const Hero = () => {

  return (
    <div className="py-5" style={{ minHeight: "calc(100vh - 85px)" }}>
      <div className="container">
        <div className="hero">
          <div className="feature__wrap">
            <div className="feature__left">
              <h2 className="feature__lead feature__lead--2">
                Contrast Bootstrap 5 UI Kit
              </h2>
              <p className="feature__text">
                Well crafted Bootstrap 5 UI kit featuring over 2000+ basic components and 10000+ pro components to build your next landing, admin, SAAS, prelaunch, etc project in record time, using clean UI components
              </p>

              <div className="feature__buttons">

                <a className="btn1 btn__inverse" target="_blank" rel="noreferrer" href="https://cdbootstrap-free-demo.netlify.app/">
                  <span className="btn__icon">
                    <svg
                      width="22"
                      height="20"
                      viewBox="0 0 22 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.0457 9.82757L8.34869 6.14804C8.03574 5.99838 7.68104 6.04213 7.44706 6.25908C7.21308 6.47602 7.14486 6.82459 7.27377 7.14506L8.51447 10.2331L7.56331 13.2171C7.46745 13.5179 7.56066 13.8628 7.80049 14.1026C7.8076 14.1097 7.81479 14.1168 7.82212 14.1237C8.07788 14.3639 8.43819 14.4416 8.73836 14.3212L16.1186 11.3601C16.4159 11.2407 16.5977 10.9495 16.5819 10.6176C16.566 10.2857 16.3555 9.97559 16.0457 9.82757ZM9.74123 12.054L10.2056 10.5971C10.2632 10.4165 10.2536 10.2154 10.1784 10.0285L9.57293 8.52147L13.6673 10.4788L9.74123 12.054Z"
                        fill="#FFF"
                      />
                      <path
                        d="M10.9994 0C4.93431 0.00010632 0 4.48605 0 9.99989C0 15.5138 4.93431 19.9999 10.9995 20C17.0651 19.9999 21.9998 15.5139 21.9998 10C21.9998 4.48594 17.065 0 10.9994 0ZM10.9994 18.4051C5.90162 18.405 1.75416 14.6345 1.75416 9.99979C1.75416 5.36531 5.9015 1.59479 10.9994 1.59469C16.0977 1.59469 20.2454 5.36521 20.2454 9.99989C20.2455 14.6345 16.0977 18.405 10.9994 18.4051Z"
                        fill="#FFF"
                      />
                    </svg>
                  </span>
                  <span className="btn__text">Preview</span>
                </a>
              </div>
            </div>
            <div className="feature__right">
              <img
                src={require('../../../components/images/aboutherofree.png')}
                alt="#"
                className="feature__img"
              />
            </div>
          </div>

          <div className="hero__icons">

            <p className="hero__icon hero__icon--html">
              <svg width="38" height="54" viewBox="0 0 38 54" fill="none">
                <path
                  d="M6.064 5.28H8.25v2.393h2.389V.528h-2.39v2.36H6.065V.529H3.676v7.145h2.388V5.28zM13.777 7.673h2.388V2.899h2.102V.528h-6.591v2.37h2.101v4.775zM21.65 4.133l1.646 2.54h.04l1.642-2.54v3.54h2.38V.528h-2.492l-1.53 2.514L21.805.528h-2.49v7.145h2.335v-3.54zM34.291 5.313h-3.358V.528h-2.388v7.145h5.746v-2.36zM.234 10.808l3.416 38.31 15.332 4.255 15.345-4.253 3.422-38.312H.234zM30.34 23.337H12.358l.43 4.811H29.91l-1.288 14.43-9.632 2.668-.006.002-9.626-2.67-.672-7.548h4.716l.35 3.915 5.233 1.414.006-.002 5.239-1.414.545-6.094H8.492L7.222 18.64h23.536l-.42 4.697z"
                  fill="#828282"
                />
              </svg>
            </p>
            <p className="hero__icon hero__icon--react">
              <img src={cssicon} alt="css icon" />
            </p>
            <p className="hero__icon hero__icon--react">
              <img src={javascripticon} alt="javascript icon" />
            </p>
            <p className="hero__icon hero__icon--facebook">
              <svg width="53" height="53" viewBox="0 0 53 53" fill="none">
                <path
                  d="M33.028 29.505a5.504 5.504 0 00-3.809-1.21h-9.402v9.621h9.556a5.416 5.416 0 003.655-1.277 4.755 4.755 0 001.454-3.61 4.602 4.602 0 00-1.454-3.524zm-1.32-6.209a3.963 3.963 0 001.32-3.17 4.007 4.007 0 00-1.167-3.282 5.152 5.152 0 00-3.236-.946h-8.808v8.499h8.808a4.844 4.844 0 003.17-1.101h-.088zM44.037 0H8.808A8.808 8.808 0 000 8.808v35.23a8.808 8.808 0 008.808 8.807h35.23a8.808 8.808 0 008.807-8.807V8.808A8.808 8.808 0 0044.038 0zm-4.822 37.102a6.605 6.605 0 01-2.026 2.73 9.952 9.952 0 01-3.545 1.806c-1.665.49-3.395.72-5.13.682H14.356V11.494H29.33c2.35-.117 4.674.549 6.606 1.893a6.715 6.715 0 012.51 5.747 6.804 6.804 0 01-1.013 3.986 7.42 7.42 0 01-3.259 2.576 6.718 6.718 0 014.404 2.686 8.983 8.983 0 011.475 5.24 8.631 8.631 0 01-.836 3.48z"
                  fill="#828282"
                />
              </svg>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
